
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 72 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#009e60","d":"M0 0h72v48H0z"}}),_c('path',{attrs:{"fill":"#fcd116","d":"M0 0h54v48H0z"}}),_c('path',{attrs:{"fill":"#0072c6","d":"M0 0h18v48H0z"}}),_c('g',{attrs:{"fill":"#009e60"}},[_c('path',{attrs:{"d":"M32 34l4 8 4-8-4-8zM27 24l4 8 4-8-4-8zM37 24l4 8 4-8-4-8z"}})])])
          )
        }
      }
    